<template>
  <div class="page-container">
    <div class="query-title">产品配置</div>

    <div class="content">
      <QueryParams
        ref="QueryParams"
        :loading="loading"
        :search-field="searchField"
        @search="queryData"
      />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="新增" @click="handleOpen('add')" />
            <table-button name="export" tip="删除" @click="handleOpen('remove')" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="left"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          />
        </Table-filter>
      </div>
    </div>

    <table-custom-filter
      ref="CustomFilter"
      :current-filter-field="currentFilterField"
      @confirm="customeFilter"
    />
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%">
      <DictEdit v-if="dialogVisible" ref="DictEdit" />
      <div slot="footer">
        <el-button size="small" type="default" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiGylPro } from '@/api/sap/client-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig from './config/productDeploy'
import DictEdit from './components/producetDictEdit.vue'
export default {
  mixins: [tableMixins],
  components: { DictEdit },
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        data: [],
        columns: []
      },
      searchField: {},
      isSetFilter: false,
      dialogVisible: false,
      dialogTitle: '新增'
    }
  },
  created() {
    this.initPage(pageConfig)
    this.gridOptions.columns = [
      { type: 'checkbox', field: 'checkbox', title: '', width: 40 },
      { field: 'product_id', title: '产品编号' },
      { field: 'product_name', title: '产品名称' },
      { field: 'chfl_text', title: '存货分类' },
    ]
  },
  methods: {
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.pagination,
        MODE: 'SELECT'
      }

      this.loading = true
      try {
        const { data, total } = await apiGylPro(params)
        if (data.length === 0 && total - 0) {
          this.queryData(1, ranges)
          return
        }
        this.gridOptions.data = data
        this.pagination.totalCount = total - 0
        // 更新计算值
        this.updateCount()
        this.gridOptions.data = data
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    async handleOpen(type) {
      if (type == 'add') {
        this.dialogVisible = true
        return
      }
      const checkedList = this.$refs['xTable'].getCheckboxRecords()
      if (!checkedList.length) return
      await this.requestApi(checkedList,'DELETE')
    },
    async submitHandle() {
      const validData = this.$refs['DictEdit'].validRows()
      if (validData) {
        await this.requestApi(validData,'INSERT')
        this.dialogVisible = false
        this.queryData()
      }
    },
    async requestApi(pdata,mode) {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        mode,
        data: pdata
      }
      const { message, msgtype } = await apiGylPro(params)
      if (msgtype === 'S') {
        this.$message.success(message)
        this.queryData()
      } else {
        this.$message.error(message)
      }
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/client-manage/productDeploy.vue